import React from 'react';
import './Header.css';

export default function Header({ onNavigate, currentView, onLogout }) {
  return (
    <header className="header">
      <h1 className="header-title">
        RockPaperRunway <span>Admin</span>
      </h1>
      <div className="header-actions">
        <button
          className={`btn ${currentView === 'blogs' ? 'btn-red' : 'btn-secondary'}`}
          onClick={() => onNavigate('blogs')}
        >
          Manage Blogs
        </button>
        <button
          className={`btn ${currentView === 'email' ? 'btn-red' : 'btn-secondary'}`}
          onClick={() => onNavigate('email')}
        >
          Email Client
        </button>
        <button className="btn btn-danger" onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
}